'use client'

import React from 'react'

import { Footer, Header, PageWrapper } from 'Components/Blocks'
import {
  HeroSection,
  ProcessSection,
  ProjectsSection,
  SolutionSection,
  WhatSection,
} from 'Components/Sections/_Legacy/Blueprint'
import { Column, Row } from 'Components/UI'
import { BlueprintPageData, ProjectsPageData } from 'Data/types'

import { first } from 'lodash'

type Props = {
  blueprintPageData?: BlueprintPageData
  projectsPageData?: ProjectsPageData
}

function BlueprintPage({ blueprintPageData, projectsPageData }: Props) {
  const pageData = blueprintPageData?.blueprintPage

  const heroData = {
    heroTitleBold: pageData?.heroTitleBold,
    heroTitleRegular: pageData?.heroTitleRegular,
    heroDiscussLinkText: pageData?.heroDiscussLinkText,
    heroSubtitle: pageData?.heroSubtitle,
    image: pageData?.image,
  }
  // const demoData = {
  //   ...first(pageData?.headerDemo),
  //   projects: blueprintPageData?.allDemoProjects,
  // }
  const whatIsItData = first(pageData?.headerWhatIsIt)
  const solutionData = first(pageData?.headerSolution)
  const processData = {
    ...first(pageData?.headerProcess),
    steps: pageData?.step,
  }

  // todo: while the demo service is down
  // const insideData = first(pageData?.blueprintPage?.headerInside)

  const projectsData = {
    projectsData: projectsPageData?.projectsPage?.projects,
    headerData: first(pageData?.headerProjects),
  }

  return (
    <PageWrapper secondary>
      <Header />

      <Column alignCenter as="main" fullWidth overflowX="hidden">
        <Row height={[76, 76, 92]} />

        <HeroSection data={heroData} />

        <WhatSection data={whatIsItData} />

        <ProcessSection data={processData} />

        <SolutionSection data={solutionData} />

        <ProjectsSection data={projectsData} />
      </Column>

      <Footer />
    </PageWrapper>
  )
}

export default BlueprintPage
